<template>
  <custom-callout
    id="customCalloutAdjust"
    border-color-hex="#FF7058"
    class="ml-2 mt-3 mb-3 pr-2"
    :has-toggle="false"
  >
    <div>
      <div class="ml-2 mb-2">
        <icon-view
          class="mt-5 mb-1 mt-md-0 mt-sm-5 pt-3"
          :gradient="false"
          icon="fas fa-money-check-alt p-1 mb-1"
          icon-background="#fe7159"
          icon-color="#fff"
          icon-size="10px"
          title="Ajustar Factura"
        />
      </div>
      <validation-observer ref="adjustForm" v-slot="{}" tag="form">
        <div class="row mt-2 mb-2 pr-4 pl-2 pt-1 pb-3">
          <div class="col-md-4">
            <span class="data-title d-block border-mobile">Razón:</span>
            <validation-provider
              v-slot="{ errors }"
              name="customDropDownReason"
              rules="required"
            >
              <custom-drop-down
                id="bill-change-status-dropdown-status"
                v-model="reasonSelected"
                :clearable="false"
                custom-error-msg="La razón es requerida."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                :options="reason"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div class="col-md-8">
            <div class="adjust-align">
              <span class="data-title d-block border-mobile ml-4">
                ¿Qué tipo de ajuste desea realizar?
              </span>

              <custom-radio-button
                id="CustomRadioTypeNivel"
                v-model="ajustSelected"
                class="m-2"
                custom-error-msg="El nivel es requerido."
                :is-disabled="false"
                is-inline
                :options="optionsAdjust"
              />
            </div>
          </div>
        </div>

        <div class="row mt-2 mb-4 pl-2 pr-4">
          <div class="col-md-3">
            <span class="data-title d-block border-mobile">Cantidad:</span>
            <validation-provider
              v-slot="{ errors }"
              :custom-messages="{
                greaterThanZero: 'La cantidad debe ser mayor que 0.',
                required: 'La cantidad es requerida.',
              }"
              name="customInputQuantity"
              rules="required|greaterThanZero"
            >
              <custom-input
                id="txtQuantityBudget"
                v-model="newAmount"
                :error="errors[0]"
                :icon-background-class="
                  ajustSelected
                    ? 'adjust-background-green'
                    : 'adjust-background-red'
                "
                placeholder="$0.00"
                :prepend-icon="
                  ajustSelected
                    ? 'fas fa-plus icon-color icon-font'
                    : 'fas fa-minus icon-color icon-font'
                "
                :prepend-icon-left="true"
                type="number"
              />
            </validation-provider>
          </div>
          <div class="col-md-5">
            <div class="align-comments">
              <span class="data-title d-block border-mobile">Comentario:</span>
              <validation-provider
                v-slot="{ errors }"
                name="customInputComment"
                rules="required"
              >
                <custom-input
                  id="bill-change-status-input-comment"
                  v-model="comment"
                  class="custom-input-con"
                  custom-error-msg="El comentario es requerido."
                  :error="errors[0]"
                  maxlength="3000"
                />
              </validation-provider>
            </div>
          </div>
          <div v-if="hasEvidenceFile" class="col-md-5">
            <div class="align-comments">
              <span class="data-title d-block border-mobile">Evidencia:</span>
              <validation-provider
                v-slot="{ errors }"
                name="adjustment-input-file"
                rules="required"
              >
                <custom-file-input
                  id="customInptFileUploadDocumentsPdf"
                  ref="documentInputRef"
                  accept="pdf"
                  class="file-input__extended"
                  custom-error-msg="El archivo es requerido."
                  display-style="normal"
                  :error="errors[0]"
                  :on-download="() => {}"
                  :value="attachment"
                  @input="(file) => onUploadFileHandler(file)"
                />
              </validation-provider>
            </div>
          </div>
          <div
            class="col-md-4 col-sm-12 d-flex justify-content-start align-items-center"
          >
            <div class="align-button-group">
              <action-button
                id="actionBtnCancelDocumentSigned"
                i="fas fa-times-circle  pl-2"
                text="Cancelar"
                variant="outline-danger mr-2 mt-4 mb-0 pr-3 pl-2"
                @click="cancel()"
              />
              <action-button
                id="actionBtnDownSavedDocumentSigned"
                i="fas fa-save fa-lg pl-2 mt-1 mb-1"
                text="Guardar"
                variant="success mt-4 mb-0  pr-3 "
                @click="saveAdjust()"
              />
            </div>
          </div>
        </div>
      </validation-observer>
    </div>
  </custom-callout>
</template>

<script>
import CustomRadioButton from 'custom-radio';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import CustomCallout from 'custom-callout';
import CustomFileInput from 'CustomFileInput';
import servicesTypes from '@/utils/constants/serviceTypes.js';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import { numberMixin } from '@/mixins/number.mixin';
import IconView from 'icon-view';
import {
  getAdjustmentReasons,
  saveBillAdjustment,
} from '@/services/provider/billing-contract.api';
import billingLevels from '@/utils/constants/billingLevels.js';
export default {
  name: 'AdjustmentBill',
  mixins: [alertMixin, numberMixin],
  components: {
    CustomRadioButton,
    CustomDropDown,

    CustomInput,
    ActionButton,
    IconView,
    CustomCallout,
    CustomFileInput,
  },
  props: {
    billId: {
      type: Number,
      default: () => {},
    },
    data: {
      type: Object,
      default: () => {},
    },
    showEvidenceAttachment: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      reasonSelected: null,
      newAmount: null,
      nivelSelected: true,
      ajustSelected: true,
      comment: null,
      optionsAdjust: [
        { label: 'Aumentar', value: true },
        { label: 'Reducir', value: false },
      ],

      reason: [],
      attachment: null,
    };
  },
  mounted() {
    this.getReason();
  },
  computed: {
    availableReasons() {
      const adjustmentReasonIds = this.adjustments.map(
        (x) => x.adjustmentReasonId
      );

      return this.visitReasons.filter(
        (x) => !adjustmentReasonIds.includes(x.id)
      );
    },
    hasEvidenceFile() {
      return this.showEvidenceAttachment;
    },
  },
  methods: {
    getReason() {
      getAdjustmentReasons().then((data) => {
        this.reason = data.data;
      });
    },
    showVisitOption() {
      if (
        this.data.serviceTypeId === servicesTypes.Therapy ||
        this.data.serviceTypeId === servicesTypes.Assistant
      ) {
        this.options = [
          {
            name: 'groupName1',
            label: 'Visita',
            value: false,
          },
          {
            name: 'groupName1',
            label: 'Resumen',
            value: true,
          },
        ];
      }
    },
    onUploadFileHandler(file) {
      this.attachment = file;
    },
    async saveAdjust() {
      const isValid = await this.$refs.adjustForm.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      } else {
        let payload = {
          billId: this.billId,
          visitId: null,
          visitSummaryId: null,
          adjustmentReasonId: this.reasonSelected.id,
          amount: this.ajustSelected
            ? Number(this.newAmount)
            : Number(this.newAmount) * -1,
          comment: this.comment,
          transactionTypeId: billingLevels.summary,
          attachment: this.attachment,
        };
        payload.amount = this.decimalNumberToOnlyTwoDigits(payload.amount);
        //Convert payload to formData
        const formData = new FormData();
        Object.keys(payload).forEach((key) => {
          formData.append(key, payload[key]);
        });

        formData.append('adjustmentReasons[0].id', this.reasonSelected.id);
        formData.append('adjustmentReasons[0].name', this.reasonSelected.name);

        await saveBillAdjustment(formData)
          .then(() => {
            this.ShowToast(
              'Proceso Exitoso.',
              'El ajuste se ha guardado exitosamente.',
              'success'
            );
            this.cancel();
            this.$emit('reload-results');
          })
          .catch((err) =>
            this.ShowToast('', err.response?.data?.message, 'error')
          );
      }
    },
    cancel() {
      this.$emit('on-cancel');
    },
    clean() {
      this.newAmount = null;
      this.comment = null;
      this.cancel();
    },
  },
};
</script>

<style lang="scss">
.adjust-align {
  width: 109%;
}
.custom-input-con ::v-deep {
  .form-control {
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #c5cdcf;
    opacity: 1;
    height: 41px;
  }
}

.container-ajust-budget {
  background-color: #f7f7f7;
  border-radius: 5px;
}
.positive {
  color: #2db782;
}
.negative {
  color: red;
}
.adjust-background-green {
  background-color: var(--green);
}
.adjust-background-red {
  background-color: var(--red);
}
.icon-font {
  color: var(--white);
  font-weight: 400;
}
.label-gray {
  color: #727272;
}
.container-text-aviable {
  margin-left: 45%;
}
.container-buttons {
  margin-left: 228px;
}
.comments {
  width: 50%;
}
.align-comments {
  margin-left: 0px;
}
.align-button-group {
  margin-top: 5px;
}
</style>
